var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isButton_(_vm.scrId, 'AD'))?_c('sf-button',{attrs:{"icon":"square-plus","onClick":_vm.openModal}},[_vm._v(_vm._s(_vm.getButtonMsg_(_vm.scrId, 'AD')))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }